import { Inplace as Inplaces } from 'primereact/inplace';  

const Inplace = ({...rest}) => {

    return (
        <Inplaces {...rest} />
    )

};

export default Inplace;